enum CorePaths {
  CreateFile = 'core/media/uploaded',
  GetAttachFileUrl = 'core/media/attach',
  GetMediaUrl = 'core/media/mediaId/',
  GetStorageLink = 'core/media/upload',
}

export default CorePaths;
